import { useCallback, useRef } from 'react';
import { useSessionContext } from '../contexts/SessionContext';
import { useSheetContext } from '../contexts/SheetContext';

/**
 * GK-5: how many tokens of the players' characters (sheet type «pc») stand on the map the players are on now —
 * the number in «перенести персонажей игроков (N)» of the confirmation of a map show.
 */
export function usePartyCount(): () => number {
  const { pages } = useSessionContext();
  // Outside the sheet provider (a bare render) there is nobody to carry: the count is 0.
  let sheets: ReadonlyArray<{ id: string; sheetType?: string }> | undefined;
  try {
    sheets = useSheetContext().sheets.sheets;
  } catch {
    sheets = undefined;
  }
  const ref = useRef({ pages, sheets });
  ref.current = { pages, sheets };
  return useCallback((): number => {
    const { pages: p, sheets: sh } = ref.current;
    const tokens = p.getPageData?.(p.activePageId)?.tokens ?? [];
    const pc = new Set((sh ?? []).filter((x) => x.sheetType === 'pc').map((x) => x.id));
    return tokens.filter((tk) => tk.characterSheetId !== undefined && pc.has(tk.characterSheetId)).length;
  }, []);
}
